module.exports = __webpack_public_path__ + "img/example-right-mobile.50a7714.png";